import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack
} from '@mui/material';
import {
  HomeRounded as HomeRoundedIcon,
  Help,
  Chat,
  Settings,
  MonetizationOn as MonetizationOnIcon,
  Analytics as AnalyticsIcon,
  WhatsApp
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../../helpers/api';

const mainListItems = [
  { text: 'Home', icon: <HomeRoundedIcon /> },
  { text: 'Analytics', icon: <AnalyticsIcon /> },
  { text: 'WhatsApp Alerts', icon: <WhatsApp /> }
];

const secondaryListItems = [
  { text: 'Support', icon: <Help /> }
];

export default function MenuContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [subscription, setSubscription] = useState<any>(null);

  useEffect(() => {
    const fetchSubscription = async () => {
      const sub = await api.get("/user/subscription");
      setSubscription(sub.data.subscription);
    };
    fetchSubscription();
  }, []);

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={location.pathname === (
                item.text === 'Home' ? '/console' :
                  item.text === 'Analytics' ? '/analytics' :
                    item.text === 'WhatsApp Alerts' ? '/whatsapp' : ''
              )}
              onClick={() => handleNavigation(
                item.text === 'Home' ? '/console' :
                  item.text === 'Analytics' ? '/analytics' :
                    item.text === 'WhatsApp Alerts' ? '/whatsapp' : ''
              )}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <List dense>
        <ListItem disablePadding sx={{ display: 'block' }}>
          <ListItemButton
            href="https://ko-fi.com/eventspy"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ListItemIcon><MonetizationOnIcon /></ListItemIcon>
            <ListItemText primary={"Donate"} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding sx={{ display: 'block' }}>
          <ListItemButton
            href="https://discord.gg/7hMTATYZme"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ListItemIcon><Chat /></ListItemIcon>
            <ListItemText primary={"Discord"} />
          </ListItemButton>
        </ListItem>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              component="a"
              href={item.text === 'Support' ? 'mailto:support@event-spy.com' : ''}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
        {subscription && Object.keys(subscription).length > 0 && (
          <ListItem disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              onClick={() => handleNavigation('/manage')}
            >
              <ListItemIcon><Settings /></ListItemIcon>
              <ListItemText primary={"Manage Subscription"} />
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </Stack >
  );
}
